<div class="wetter_content_container">
  <div class="bericht-text-container">
    <h3>Schlagzeile</h3>
    {{onlineVorhersageBericht?.schlagzeile}}
  </div>
  <div class="bericht-text-container">
    <h3>Wetterlage</h3>
    {{onlineVorhersageBericht?.wetterlage}}
  </div>
  <div class="bericht-text-container">
    <h3>Vorhersagen</h3>
    <ng-container *ngFor="let v of onlineVorhersageBericht?.vorhersagen?.vorhersageListe">
      <span class="bericht-text-sub-label">{{v.beschreibung}} - {{v.datum | date: 'EEE dd.MM'}}</span>
      {{v.text}}
      <span class="bericht-text-sub-label">Wind</span>
      {{v.wind}}
    </ng-container>
  </div>
  <div class="bericht-text-container">
    <h3>Aussichten</h3>
    <ng-container *ngFor="let aussichtTag of onlineVorhersageBericht?.aussichten?.aussichtsListe">
      <span class="bericht-text-sub-label">{{aussichtTag.datum | date: 'EEE dd.MM'}}</span>
      {{aussichtTag.text}}
    </ng-container>
  </div>
</div>
